import { Pipe, PipeTransform } from '@angular/core';
import { startCase, toLower } from 'lodash';

@Pipe({
    name: 'titleize',
    standalone: false
})
export class TitleizePipe implements PipeTransform {
  transform(value: string): string {
    if (value == null || value === '') {
      return '';
    }
    return startCase(toLower(String(value)));
  }
}
